module.exports = __webpack_public_path__ + "img/benjike posledny.77eb5924.png";